// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import Element from 'element-ui'
import axios from 'axios'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'


Vue.config.productionTip = false
Vue.prototype.$axios = axios 
Vue.use(Element)

Vue.use(Viewer)


import global from '../public/static/config.js'
Vue.prototype.$global = global

Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})


new Vue({
  el: '#app',
  data(){
    return {
      fontState: localStorage.getItem("isOLD") == "true"
    }
  },
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js